import {ActionTree} from 'vuex';
import axios from '@/network/api';
import {AxiosResponse, AxiosError} from 'axios';
import {AppEventState} from '@/models/AppEventState';

export const actions: ActionTree<AppEventState, {}> = {
    fetchUserEvent({commit}) {
        axios
            .get('/event')
            .then((response: AxiosResponse) => {
                commit('setEventData', response.data.data as AppEventState);
            }).catch((error: AxiosError) => {
            console.log('Invalid Event Code');
        });
    },
    fetchEventByCode({commit}, code: string) {
        axios
            .get('/event_by_code?code=' + code)
            .then((response: AxiosResponse) => {
                commit('setEventData', response.data.data as AppEventState);
            }).catch((error: AxiosError) => {
            console.log(error);
        });
    },
};
